import { WhyLetter } from "./sections/WhyLetter";

/**
 * The front door. The whole "why this exists" letter is the landing page:
 * read the story, join the community, read the whole site, or play the harbour.
 */
export function StoryLanding({
  onJoin,
  onPlay,
  onReadMore,
}: {
  onJoin: () => void;
  onPlay: () => void;
  onReadMore: () => void;
}) {
  return <WhyLetter onJoin={onJoin} onPlay={onPlay} onReadMore={onReadMore} />;
}
